import {Button, type ButtonProps} from "primereact/button";

interface TooltipButtonProps extends ButtonProps {
    /** Classes for the wrapping element, e.g. layout classes the button would otherwise carry. */
    wrapperClassName?: string;
}

/**
 * Button whose tooltip also shows while it is disabled, e.g. to say why it cannot be used yet. PrimeReact's
 * `showOnDisabled` needs a wrapping element, otherwise re-rendering the disabled button throws.
 */
export default function TooltipButton({wrapperClassName, tooltipOptions, ...props}: TooltipButtonProps) {
    return (
        <span className={wrapperClassName}>
            <Button {...props} tooltipOptions={{position: "top", ...tooltipOptions, showOnDisabled: true}} />
        </span>
    );
}
